"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const lib_1 = require("@brandfree-front/lib");
const mobx_react_1 = require("mobx-react");
const GaButton_1 = __importDefault(require("../../util/GaButton"));
const StoresUtil_1 = require("../../util/StoresUtil");
let GDPRChoice = class GDPRChoice extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { id, text, checked, onChange } = this.props;
        return (react_1.default.createElement(lib_1.Check, { id: id, value: id, size: "large", checked: checked, onChange: onChange, extraContent: this.getExtraContent(), labelText: 'gdpr-choice' },
            react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: text } })));
    }
    getExtraContent() {
        const { description, onDetailsClick } = this.props;
        const { translate } = this.translateStore;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            typeof description !== 'string' && description,
            react_1.default.createElement(lib_1.Text, null,
                typeof description === 'string' && react_1.default.createElement("p", { className: "text-tiny text-color-normal" }, description),
                react_1.default.createElement(GaButton_1.default, { id: "gdpr-choices-extra-info", className: "text__margin-half", link: true, text: translate('gdpr.extraInfo'), size: "small", iconRight: "#arrow-right", onClick: onDetailsClick }))));
    }
};
GDPRChoice = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], GDPRChoice);
exports.default = GDPRChoice;
